import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnApplianceStatus } from '@lib/api/entities';

@Component({
  selector: 'sn-appliance-status',
  templateUrl: './appliance-status.component.html',
  styleUrls: ['./appliance-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApplianceStatusComponent {
  @Input()
  public status: SnApplianceStatus;

  public readonly APPLIANCE_STATUS = SnApplianceStatus;
}
